module.exports = __webpack_public_path__ + "static/media/kariIgew.c3169914.jpg";